import React from 'react';
import './Settings.css';

function InterviewScheduling({ onBack }) {
    return (
        <div className="settings-component-wrapper">
            <button className="back-button" onClick={onBack}>
                <span className="back-icon">←</span>
                <span>Back to TA Settings</span>
            </button>

            <div className="settings-component-content">
                <div className="settings-component-header">
                    <h1>📅 Interview Scheduling</h1>
                    <p>Configure interview types and scheduling rules</p>
                </div>

                <div className="settings-component-body">
                    <div className="settings-info-card">
                        <h3>Interview Scheduling Features</h3>
                        <p>This section will allow you to:</p>
                        <ul>
                            <li>Define interview types</li>
                            <li>Configure scheduling rules</li>
                            <li>Set interviewer availability</li>
                            <li>Manage interview panels</li>
                        </ul>
                    </div>

                    <div className="settings-placeholder-message">
                        <span className="placeholder-icon">🚧</span>
                        <p>Interview Scheduling configuration coming soon...</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InterviewScheduling;
